<app-dashboard-menu [menuData]="menuData"></app-dashboard-menu>
<div class="content">
  <router-outlet></router-outlet>
</div>
